import { get as lodashGet } from "lodash-es";
import { createSelector } from "reselect";
import { FEATURE_FLAGS } from "./constants";
import { getCurrentConfig } from "@certa/queries/hooks/config.hook";
import { getUserQueryData } from "@certa/queries/hooks/authV2.hooks";

/**
 * To check whether Actvity Logs are grouped by request_id or not
 * @returns {boolean} returns true if feature is enabled
 * @deprecated This feature is no longer in use
 */
export const isCERTA2Enabled = () =>
  !!getCurrentConfig()?.custom_ui_labels?.specialFeatures?.includes(
    FEATURE_FLAGS.NEW_UI_ENABLED
  );

const getCurrentUserGroups = state =>
  lodashGet(getUserQueryData(), "groups", []);

export const isSupplierUser = state => {
  return lodashGet(getUserQueryData(), "kind", 0) === 2;
};

/**
 * Provides a Set<Numner> of current user's user group IDs.
 * @returns {Set<Number>} Set of current user's user-group IDs
 */
export const getCurrentUserGroupIDs = createSelector(
  getCurrentUserGroups,
  userGroups => new Set(userGroups.map(group => group.id))
);
